import styled, { css } from "styled-components";
import { Link } from "gatsby";

import { IS_SMALL, IS_MEDIUM } from "~/utils/media";
import {
  Small,
  HeroSubheadline,
} from "~/components/typography";

export const PdpWrapper = styled.div``;

export const PdpHeroWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-top: 120px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 60%;
    max-width: 560px;
    height: 80%;
    background-color: ${({ theme }) => theme.colors.accentTwo};
    border-bottom-right-radius: 128px;
  }

  &:before {
    left: auto;
    right: 100%;
    border-bottom-right-radius: 0;
  }

  ${IS_MEDIUM} {
    &:before,
    &:after {
      width: 50%;
    }
  }

  ${IS_SMALL} {
    flex-direction: column;
    padding-top: 88px;

    &:before {
      display: none;
    }

    &:after {
      width: calc(100% + 2rem);
      max-width: none;
      height: 40vh;
      margin-left: -1rem;
      border-bottom-right-radius: 0;
    }
  }
`;

export const PdpImage = styled.div`
  width: 60%;
  max-width: 560px;
  padding-right: 2rem;

  * > * {
    margin-bottom: 2rem;
  }

  figure {
    margin-left: auto;
  }

  ${IS_MEDIUM} {
    width: 50%;

    figure {
      margin: auto;
    }
  }

  ${IS_SMALL} {
    width: 100%;
    max-width: none;
    padding: 0;

    // TODO: Put these images in a carousel
    figure:last-child {
      display: none;
    }
  }
`;

export const PdpInfo = styled.div`
  position: sticky;
  top: 6rem;
  flex-grow: 1;
  max-width: 40%;
  padding: 0 0 3rem 4rem;
  color: ${({ theme }) => theme.colors.accentThree};

  ${IS_MEDIUM} {
    max-width: 50%;
  }

  ${IS_SMALL} {
    max-width: none;
    padding: 0 1rem;
  }
`;

export const PdpFinePrint = styled(Small)`
  margin-top: 0.5rem;
  text-align: center;
`;

export const PdpInfoBlock = styled.div`
  display: block;
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PdpInfoItem = styled.div`
  display: flex;
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PdpInfoTitle = styled(PdpInfoItem)`
  display: block;
  margin-bottom: 2rem;
`;

export const PdpInfoIcon = styled.div`
  ${({ src }) => src && css`
    display: block;
    min-width: 24px;
    height: 24px;
    background-image: url(${src});
    background-size: cover;
  `}
`;

export const PdpInfoLabel = styled.div`
  margin-left: 0.5rem;
`;

export const PdpEyebrow = styled(Link)`
  ${({ theme }) => theme.typography.body};
  color: ${({ theme }) => theme.colors.accentThree};

  & + ${HeroSubheadline} {
    display: block;
    margin-top: 0.5rem;

    &:before {
      display: none;
    }
  }
`;
